import React, { useEffect } from 'react';
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import MarketingPosts from '../../components/MarketingPosts';
import LocalStorageHelper from '../../helpers/localStorageHelpers';
import TopBar from '../../components/TopBar';
import './style.scss';
import { isChristmasSeason } from '../../helpers/utils';

import { Snowfall } from '@urbanpiper-engineering/horizon';
import '@urbanpiper-engineering/horizon/dist/main.css';

function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const EXCLUDE_ROUTES = ['/login/password'];

  useEffect(() => {
    // Apply the entry URL's app scope up-front. A plain visit (no ?app=)
    // clears any stored app-login so a stale scope from an earlier ?app=
    // entry doesn't keep filtering businesses to a single app. In-flow
    // navigations (e.g. "Change" from the password screen) don't remount
    // this layout, so a scope captured on entry survives the login flow.
    LocalStorageHelper.setAppLogin(searchParams.get('app'));

    if (
      LocalStorageHelper.getAccessToken() &&
      !searchParams.get('token') &&
      !EXCLUDE_ROUTES.includes(location?.pathname)
    ) {
      navigate('/business');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col h-screen">
      <TopBar showLogout={false} />
      {isChristmasSeason() && <Snowfall active={true} count={75} />}
      <div className="login-wrapper flex-1">
        <div className="max-container flex items-center flex-grow w-full">
          <div className="post-wrapper">
            <MarketingPosts />
          </div>
          <div className="outlet-wrapper">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
